export const shapeFields = [
    {
        dataField: "Population",
        dataType: 'number',
        caption: 'Population',
        format: {
            type: 'fixed',
            decimals: 0,
            useSeparator: true
        },
    },
    {
        dataField: "HousingUnitsSFDetached",
        dataType: 'number',
        caption: 'Housing Units (SFD)',
        format: {
            type: 'fixed',
            decimals: 0,
            useSeparator: true
        },
    },
    {
        dataField: "MedianIncome",
        dataType: 'number',
        caption: 'ACS Med Income',
        format: {
            type: 'money',
            decimals: 0,
            useSeparator: true
        },
    },
    {
        dataField: "MedianHomeValue",
        dataType: 'number',
        caption: 'Median Home Value',
        format: {
            type: 'money',
            decimals: 0,
            useSeparator: true
        },
    },
    {
        dataField: "MedianRent",
        dataType: 'number',
        caption: 'Median Rent',
        format: {
            type: 'money',
            decimals: 0,
            useSeparator: true
        },
    },
    {
        dataField: "OwnerOccupiedPctSFDetached",
        dataType: 'number',
        caption: 'Owner Occupied (SFD)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
    },



    {
        dataField: "PopulationGrowth1Yr",
        dataType: 'number',
        caption: 'Population Growth (1Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },
    {
        dataField: "PopulationGrowth5Yr",
        dataType: 'number',
        caption: 'Population Growth (5Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },

    {
        dataField: "MedianIncomeGrowth1Yr",
        dataType: 'number',
        caption: 'ACS Med Income Growth (1Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },
    {
        dataField: "MedianIncomeGrowth5Yr",
        dataType: 'number',
        caption: 'ACS Med Income Growth (5Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },
    {
        dataField: "UnemploymentRate",
        dataType: 'number',
        caption: 'Unemp Rate',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true
        },
        extraField: true
    },
    {
        dataField: "UnemploymentRateChg1Yr",
        dataType: 'number',
        caption: 'Unemp Rate Chg (1Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true
        },
        extraField: true
    },
    {
        dataField: "UnemploymentRateChg5Yr",
        dataType: 'number',
        caption: 'Unemp Rate Chg (5Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true
        },
        extraField: true
    },
    {
        dataField: "EmploymentGrowth1Yr",
        dataType: 'number',
        caption: 'Employment Growth (1Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },
    {
        dataField: "EmploymentGrowth5Yr",
        dataType: 'number',
        caption: 'Employment Growth (5Yr)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },    
    {
        dataField: "RenterOccupiedPctSFDetached",
        dataType: 'number',
        caption: 'Renter Occupied (SFD)',
        format: {
            type: 'fixed',
            decimals: 1,
            useSeparator: true,
            unitPrefix: "%"
        },
        extraField: true
    },
    {
        dataField: "NetMigration1Yr",
        dataType: 'number',
        caption: 'Net Migration (1Yr)',
        format: {
            type: 'fixed',
            decimals: 0,
            useSeparator: true
        },
        extraField: true
    },
    {
        dataField: "NetMigration5Yr",
        dataType: 'number',
        caption: 'Net Migration (5Yr)',
        format: {
            type: 'fixed',
            decimals: 0,
            useSeparator: true
        },
        extraField: true
    },
    {
        dataField: "HPA1Yr",
        dataType: 'number',
        caption: 'HPA 12mo',
        format: {
            type: 'percent',
            decimals: 1,
            useSeparator: true
        },
        extraField: true
    }
];
  